// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__30e4f","paramInput":"JobSimulator_paramInput___kb3-","input":"JobSimulator_input__1yI5R"};